import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IResponse,
  IDropdownResponse,
  IWarrantyMessage,
  IWarrantyMessageQueryParams
} from '../models';

const baseUrl = '/api/warranty-inquiries';

export const getWarrantyMessages = async (
  filters?: IWarrantyMessageQueryParams
): Promise<IResponse<IWarrantyMessage[]>> => {
  try {
    const { data } = await axios.get(baseUrl, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getWarrantyMessages failed');
    return Promise.reject(error);
  }
};

export const getWarrantyMessageJobStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/job-statuses`);
    return data;
  } catch (error) {
    logError(error, 'getWarrantyMessageJobStatuses failed');
    return Promise.reject(error);
  }
};

export const exportWarrantyMessages = async (
  filters?: IWarrantyMessageQueryParams
): Promise<any> => {
  try {
    const response = await axios.get(`${baseUrl}/export`, {
      params: filters,
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    logError(error, 'exportWarrantyMessages failed');
    return Promise.reject(error);
  }
};
